import { Button } from "@mui/material";
import { PackagePlans } from "../assets/packages";
import { forwardRef } from "react";

const packages = ['Basic', 'Standard', 'Pro', 'Custom'];
const PackageCard = ({type, perks, fnc})=>{

    return (
        <>
            <div className="cardWrapper  flex-[100%] sm:flex-[40%] lg:flex-1 flex-shrink-0 p-4 w-fit flex flex-col justify-between items-center gap-6 bg-[var(--surface)] border border-[var(--card-outline)] rounded-sm">
                <div className="text-center">
                    <small className=" header uppercase w-full font-medium tracking-widest">{type}</small>
                    <ul className=" perksWrapper mt-2 w-fit">
                        {perks.map((perk, i) => (
                            <li className="subheader text-center mb-3 text-[var(--text-m)]" key={i}>
                                {perk}
                            </li>
                        ))}
                    </ul>
                </div>
                <Button 
                    variant="contained"
                    onClick={fnc}
                    sx={{backgroundColor : '#FFFFFF', color: '#0A0A0A', fontWeight:'600',
                        '&:hover': {color : '#FFFFFF', backgroundColor:'#141414' }
                    }}
                >
                    get package
                </Button>
            </div>
        </>
    )
}


export const OurServicesSection = forwardRef(({packFunc, func}, ref) =>{
    return(
        <>
            <section className="mainWrapper min-h-fit flex flex-col items-center justify-center py-[15vh] gap-10" >
                <h4 className="header capitalize" style={{textShadow:'2px 2px 5px rgba(0, 0, 0, 1)'}}>our services</h4>
                <h6 className="subheader text-center" style={{textShadow:'2px 2px 5px rgba(0, 0, 0, 0.6)'}}>
                    We engineer digital marvels to catapult your business into the future. Explore our transformative array of offerings, each a testament to boundless innovation and unparalleled excellence.
                </h6>
                <div className=" w-full">
                    <div className="packageCards flex flex-wrap items-stretch gap-4 w-full">
                        {
                            PackagePlans.map((plan, i) => (
                                <PackageCard {...plan} fnc={()=>packFunc(packages[i])} key={i} />
                            ))
                        }
                    </div>
                    <small className="text-center font-normal text-[var(--text-m)] mt-4 block">
                        Note: Additional charges may apply for web maintenance. <span><Button ref={ref} size="small" sx={{color:"#FFFFFF", fontWeight:'600', padding:0 ,'&:hover': {backgroundColor: 'transparent' }}} onClick={func}><small>Contact us</small></Button></span> for more details.
                    </small>
                </div>
            </section>
        </>
    )
})